<script setup lang="ts">
import { onMounted, ref } from 'vue'
import Dashboard from './dashboards/Dashboard.vue'
import CardShortCut from '@/app/home/components/CardShortCut.vue'
import type { ICardOptions } from '@/app/home/interfaces/IDashboard'

const tabActive = ref('0')
// CONSTANTS -----------------------------------------------------------------------------------------
const items = ref<ICardOptions[]>([
  { label: 'Servicios', icon: 'pi pi-briefcase', bgColor: '#effbfc91', color: '#2399b5', link: '/service', perm: 'NOMENCLADOR:GESTION-SERVICIOS' },
  { label: 'Calendario', icon: 'pi pi-calendar', bgColor: '#effbfc91', color: '#2399b5', link: '/calendar', perm: 'CALENDARIO:GESTION-CALENDARIO' },
  { label: 'Citas', icon: 'pi pi-calendar-plus', bgColor: '#effbfc91', color: '#2399b5', link: '/appointment', perm: 'CALENDARIO:GESTION-CITAS' },
  { label: 'Pacientes', icon: 'pi pi-star', bgColor: '#effbfc91', color: '#2399b5', link: '/new-patient', perm: 'PACIENTE:GESTION-PACIENTES' },
  { label: 'Pago', icon: 'pi pi-dollar', bgColor: '#effbfc91', color: '#2399b5', link: '/payment', perm: 'CONTABILIDAD:GESTION-PAGO' },
  { label: 'Firma Digital', icon: 'pi pi-file-pdf', bgColor: '#effbfc91', color: '#2399b5', link: '/signature', perm: 'PACIENTE:GESTION-PACIENTES' },
  { label: 'Cirugía', icon: 'pi pi-pencil', bgColor: '#effbfc91', color: '#2399b5', link: '/surgery-planning', perm: 'ATENCION MEDICA:CIRUGIA:MENU' },
  { label: 'Hospitalización', icon: 'pi pi-building', bgColor: '#effbfc91', color: '#2399b5', link: '/attention-rooms', perm: 'ATENCION MEDICA:HOSPITALIZACION:MENU' },

  // { label: 'Pantallas de Turnos', icon: 'pi pi-desktop', bgColor: '#effbfc91', color: '#2399b5', link: '/shift-view', perm: 'TURNERO:PANTALLA-TURNOS' },
  // { label: 'Turnero', icon: 'pi pi-ticket', bgColor: '#effbfc91', color: '#2399b5', link: '/shift/register', perm: 'TURNERO:GENERATE-TURN' },
  // { label: 'Balcón de servicios', icon: 'pi pi-money-bill', bgColor: '#effbfc91', color: '#2399b5', link: '/shift/services-desk', perm: 'TURNERO:BALCON-SERVICIO' },
  // { label: 'Atención Médica', icon: 'pi pi-megaphone', bgColor: '#effbfc91', color: '#2399b5', link: '/turner-specialties', perm: 'TURNERO:ATENCION-MEDICA' },
])
// -------------------------------------------------------------------------------------------------------
// TABLE OPTIONS -----------------------------------------------------------------------------------------

// -------------------------------------------------------------------------------------------------------

// FUNCTIONS ---------------------------------------------------------------------------------------------

// -------------------------------------------------------------------------------------------------------

// TRIGGER FUNCTIONS -------------------------------------------------------------------------------------
onMounted(() => {
})

// -------------------------------------------------------------------------------------------------------
</script>

<template>
  <!-- Header -->
  <HeaderWithButtonComponent>
    <template #title>
      <div class="flex align-items-center">
        Inicio
      </div>
    </template>
  </HeaderWithButtonComponent>
  <div class="flex flex-col p-0">
    <!-- Tabs -->
    <Tabs value="0" class="w-full" @update:value="($event) => { tabActive = $event.toString() }">
      <TabList>
        <Tab class="py-2" value="0" :class="`${tabActive === '0' ? 'bg-primary-50' : 'bg-primary'}`">
          Inicio
        </Tab>
        <Tab class="py-2" value="1" :class="`${tabActive === '1' ? 'bg-primary-50' : 'bg-primary'}`">
          Indicadores
        </Tab>
      </TabList>

      <!-- Aquí agregamos flex-1 y overflow-auto para que sea scrollable si el contenido excede -->
      <TabPanels class="overflow-auto custom-background" style="height: calc(100vh - 7rem); position: relative">
        <TabPanel value="0">
          <div class="flex flex-wrap mt-2 lg:mt-2" style="height: max-content;">
            <div v-for="(item, index) of items" :key="index">
              <IfCan v-if="item.perm" :perms="[item.perm]">
                <div class="gap-4 col-6 w-auto sm:col-4 md:col-3 lg:col-2 xl:col-2 justify-content-center">
                  <CardShortCut :items="item" />
                </div>
              </IfCan>
            </div>

            <!-- <NuxtImg
              src="/layout/images/home/informe-medico.png"
              style="position: absolute; bottom: 0; right: 0; width: 50rem; height: 50rem; opacity: 0.08; z-index: -10;"
            /> -->
          </div>
        </TabPanel>
        <TabPanel value="1">
          <Dashboard v-if="tabActive === '1'" />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>

<style scoped>
.p-container {
  min-height: 75vh;
}
.custom-background {
  background-image: url('/layout/images/home/informe-medico.png');
  background-repeat: no-repeat;
  background-position: right bottom;
}
</style>
